import { graphBackFill, graphDefault } from './';
export const graphOverviewAxisFilter = (theme, parameters) => {
  const backFill = graphBackFill(theme, parameters);
  const graphDefaultPattern = graphDefault(theme, parameters);
  switch (theme.baseThemeName) {
    case 'dark':
      {
        const color = graphDefaultPattern.n_3;
        return {
          color,
          fillColor: color,
          fillTransparency: 0.7
        };
      }
    case 'high-contrast':
      {
        const color = backFill.fillColor;
        return {
          color,
          fillColor: color,
          fillTransparency: 0.5
        };
      }
    default:
      {
        const color = graphDefaultPattern.n4;
        return {
          color,
          fillColor: color,
          fillTransparency: 0.7
        };
      }
  }
};
//# sourceMappingURL=graphOverviewAxisFilter.js.map